import { createStore, combineReducers, applyMiddleware } from "redux"
import thunkMiddleware from "redux-thunk"
import cartReducer from "@/redux/cartReducer"
import chartsReducer from "@/redux/chartsReducer"
import postsReducer from "@/redux/postsReducer"
import notificationsReducer from "@/redux/notificationsReducer"
import tasksReducer from "@/redux/tasksReducer"
import programsReducer from "@/redux/programsReducer"
import orgReducer from "@/redux/orgReducer"
import featuredItemsReducer from "@/redux/featuredItemsReducer"
import settingsTriggerReducer from "@/redux/settingsTriggerReducer"
import bannerReducer from "@/redux/bannerReducer"
import departmentsReducer from "@/redux/departmentReducer"
import postTypesReducer from "@/redux/postTypesReducer"
import goalsReducer from "@/redux/goalsReducer"
import deviceReducer from "@/redux/deviceReducer"
import surveyCountReducer from "@/redux/surveyCountReducer"
import goalCategoriesReducer from "@/redux/goalCategoryReducer"
import servicesReducer from "@/redux/servicesReducer"
import languagesReducer from "@/redux/languagesReducer"
import periodsReducer from "@/redux/periodsReducer"
import countriesReducer from "@/redux/countriesReducer"
import catalogsReducer from "@/redux/catalogsReducer"
import commonsReducer from "@/redux/commonsReducer"
import streamedMessagesReducer from "@/redux/streamedMessagesReducer"
import whatsappTriggerReducer from "@/redux/whatsappTriggerReducer"
import eventReducer from "@/redux/eventsReducer"
import meReducer from "@/redux/meReducer"
import accountReducer from "@/redux/accountReducer"
import filedAnnouncementsReducer from "./filedAnouncementsReducer"
import suggestionsReducer from "@/redux/suggestionsReducer"

const rootReducer = combineReducers({
  cart: cartReducer,
  me: meReducer,
  account: accountReducer,
  posts: postsReducer,
  charts: chartsReducer,
  notifications: notificationsReducer,
  tasks: tasksReducer,
  programs: programsReducer,
  org: orgReducer,
  featuredItems: featuredItemsReducer,
  showSettings: settingsTriggerReducer,
  showWhatsapp: whatsappTriggerReducer,
  banner: bannerReducer,
  departments: departmentsReducer,
  post_types: postTypesReducer,
  goals: goalsReducer,
  device: deviceReducer,
  pendingSurveys: surveyCountReducer,
  categories: goalCategoriesReducer,
  services: servicesReducer,
  languages: languagesReducer,
  periods: periodsReducer,
  countries: countriesReducer,
  catalogs: catalogsReducer,
  commons: commonsReducer,
  streamedMessages: streamedMessagesReducer,
  event: eventReducer,
  announcements: filedAnnouncementsReducer,
  suggestions: suggestionsReducer,
})
// createStore deprecated?
// devtoolsEnhancer middleware goes here (see redux-devtools-extension)
// const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunkMiddleware)));
const store = createStore(rootReducer, applyMiddleware(thunkMiddleware))
export default store
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
